import { useQuery } from '@tanstack/react-query'
import platformSubscriptionsApi, {
    PricingResponse,
} from '@wtf/shared/api/platformSubscriptions'

/**
 * Hook to fetch Stripe pricing for all subscription plans
 */
export function usePricing() {
    return useQuery<PricingResponse, Error>({
        queryKey: ['platform-pricing'],
        queryFn: () => platformSubscriptionsApi.getPricing(),
        staleTime: 30 * 60 * 1000, // 30 minutes
        gcTime: 60 * 60 * 1000, // 1 hour
        retry: 3,
    })
}
